import React, { SVGProps } from 'react';

export const ValidationErrorSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_1470_43780)'>
      <path
        d='M8 8.93339V4.2667M8.00003 10.8001C7.95388 10.8001 7.90877 10.8138 7.8704 10.8394C7.83203 10.8651 7.80212 10.9015 7.78446 10.9441C7.7668 10.9868 7.76218 11.0337 7.77118 11.079C7.78019 11.1242 7.80241 11.1658 7.83504 11.1984C7.86767 11.2311 7.90925 11.2533 7.95451 11.2623C7.99977 11.2713 8.04669 11.2667 8.08933 11.249C8.13196 11.2313 8.1684 11.2014 8.19404 11.1631C8.21968 11.1247 8.23337 11.0796 8.23337 11.0334C8.23337 10.9715 8.20878 10.9122 8.16503 10.8684C8.12127 10.8247 8.06192 10.8001 8.00003 10.8001ZM1.32975 8.79717C1.1186 8.58577 1 8.2992 1 8.00041C1 7.70162 1.1186 7.41505 1.32975 7.20365L7.20355 1.33047C7.30805 1.22571 7.43219 1.1426 7.56886 1.0859C7.70553 1.02919 7.85204 1 8 1C8.14797 1 8.29448 1.02919 8.43114 1.0859C8.56781 1.1426 8.69195 1.22571 8.79645 1.33047L14.6703 7.20365C14.8814 7.41505 15 7.70162 15 8.00041C15 8.2992 14.8814 8.58577 14.6703 8.79717L8.79645 14.6704C8.58515 14.8815 8.29869 15 8 15C7.70132 15 7.41485 14.8815 7.20355 14.6704L1.32975 8.79717Z'
        stroke='#E02424'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_1470_43780'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
